/* Pack selection only. Dosages/reach remain server-provided SML snapshot data. */
(function () {
  'use strict';
  function sizeOf(v, animal) {
    var d = v.dosage || {};
    return ((d[animal] || d.dog || d.cat || {}).size || '').toLowerCase();
  }
  function choices(variants, animal, form, variation, direct, linkedVariantId) {
    return variants.filter(function (v) {
      if (v.dosage_form !== form || (v.variation && v.variation !== variation)) return false;
      // A native product link may select its existing buyable pack without
      // making that pack eligible for advice or exposing every extra pack.
      var linkedPack = direct && v.id === linkedVariantId && v.purchasable;
      if (!linkedPack && (v.exclude_from_advisor || !/^[sml]$/.test(sizeOf(v, animal)))) return false;
      var d = v.dosage && v.dosage[animal];
      return direct || (d && d.active && d.size);
    }).sort(function (a, b) {
      return ((a.pack || {}).quantity || 0) - ((b.pack || {}).quantity || 0);
    });
  }
  function duration(rows, weight, id, size) {
    var row = (rows || []).find(function (r) { return r.weight_kg === weight; });
    if (!row || !Array.isArray(row.variants)) return null;
    var item = row.variants.find(function (v) { return v.variant_id === id; });
    // Only legacy index-based snapshots may fall back to a size match.
    if (!item && size && row.variants.every(function (v) { return v.variant_id < 1000; })) {
      item = row.variants.find(function (v) { return v.size === size; });
    }
    return item && Number.isFinite(item.duration_days) && item.duration_days > 0 ? item.duration_days : null;
  }
  function recommend(cards, target) {
    var sorted = cards.filter(function (c) { return !c.variant.exclude_from_advisor && c.durationDays != null; })
      .sort(function (a, b) { return Math.abs(a.durationDays - target) - Math.abs(b.durationDays - target); });
    if (!sorted.length) return null;
    var best = sorted[0];
    // Approved V5b choice: close S/M ties (one day) prefer M.
    return (best.size === 'S' && sorted.find(function (c) {
      return c.size === 'M' && Math.abs(c.durationDays - target) <= Math.abs(best.durationDays - target) + 1;
    })) || best;
  }
  function orderVariations(keys, specs) {
    var order = (specs || []).map(function (spec) { return spec.key; });
    return keys.slice().sort(function (a, b) {
      var ai = order.indexOf(a), bi = order.indexOf(b);
      if (ai < 0) ai = order.length;
      if (bi < 0) bi = order.length;
      return ai - bi || a.localeCompare(b);
    });
  }
  window.SmlPackChoice = { orderVariations: orderVariations, sizeOf: sizeOf, choices: choices, duration: duration, recommend: recommend };
})();
